import { Drawer, Flex, SkeletonBox, SkeletonText, Space, Spacing } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { Separator } from '../Separator'
import * as Styled from './styles'

interface TransactionDrawerSkeletonProps {
  transactionNo: number | null | undefined
}

const BOOKING_LINE_COUNT = 2
const DETAIL_LINE_COUNT = 3

export const TransactionDrawerSkeleton = ({ transactionNo }: TransactionDrawerSkeletonProps) => {
  const { t } = useTranslation()

  return (
    <>
      <Drawer.Header closable title={t('ledger.drawer_title', { number: transactionNo })} />
      <Drawer.Body withPadding={false} gap="0">
        <Flex flexDirection="column" alignItems="center" justifyContent="center">
          <Space size="s24" />
          <SkeletonBox height={20} width={64} />
          <Space size="s8" />
          <SkeletonText variant="h1" width={128} />
          <Space size="s4" />
          <SkeletonText variant="bodySM" width={144} />
          <Space size="s24" />
        </Flex>
        <Separator />
        <Styled.SectionWrapper>
          <Flex flexDirection="column">
            <SkeletonText width={88} />
            <Space size="s16" />
            {Array.from({ length: BOOKING_LINE_COUNT }).map((_, index) => (
              <Styled.BookingLineWrapper key={index}>
                <Flex flexDirection="column" gap={Spacing.S4}>
                  <SkeletonText width={120} />
                  <SkeletonText variant="bodySM" width={64} />
                </Flex>
                <Flex flexDirection="column" alignItems="flex-end" gap={Spacing.S4}>
                  <SkeletonText width={72} />
                  <SkeletonText variant="bodySM" width={48} />
                </Flex>
              </Styled.BookingLineWrapper>
            ))}
          </Flex>
        </Styled.SectionWrapper>
        <Separator />
        <Styled.SectionWrapper>
          <Flex flexDirection="column">
            <SkeletonText width={64} />
            <Space size="s8" />
            {Array.from({ length: DETAIL_LINE_COUNT }).map((_, index) => (
              <Styled.DetailLineWrapper key={index}>
                <SkeletonText width={80} />
                <SkeletonText width={112} />
              </Styled.DetailLineWrapper>
            ))}
          </Flex>
        </Styled.SectionWrapper>
      </Drawer.Body>
    </>
  )
}
